__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/9c4245c/_next/";